import ApiModelWithAuth from "../../../models/ApiModelWithAuth";

// Права (read-only каталог, authorized/admin/permissions) — чекбоксы на карточке роли.
export default class ApiPermission extends ApiModelWithAuth {
    pathDef = 'authorized/admin/permissions';
    formatterItem = null;
}
